export default [
    {
        path: 'relatorio-alto-custo-processo-paciente',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-alto-custo-processo-paciente' */
            '@/views/farmacia/relatorio-alto-custo-processo-paciente/Index'
        ),
        redirect: 'relatorio-alto-custo-processo-paciente/index',
        children: [
            {
                name: 'farmacia-relatorio-alto-custo-processo-paciente-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-alto-custo-processo-paciente' */
                    '@/views/farmacia/relatorio-alto-custo-processo-paciente/List.vue'
                ),
            },
        ],
    },
]